import React, { useState } from 'react';

interface IProps {
  disabled: boolean;
  isStreaming: boolean;
  onSend: (text: string) => void;
  onStop: () => void;
}

const ChatComposer = ({ disabled, isStreaming, onSend, onStop }: IProps) => {
  const [draft, setDraft] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const text = draft.trim();
    if (!text || isStreaming || disabled) return;
    onSend(text);
    setDraft('');
  };

  return (
    <form className="chat-form" onSubmit={submit}>
      <input
        type="text"
        aria-label="Message"
        placeholder={
          disabled
            ? 'The assistant is not available here'
            : 'Ask about an order, a lot, a kitter…'
        }
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        autoComplete="off"
        disabled={disabled}
      />
      {isStreaming ? (
        <button
          type="button"
          className="btn-app btn-app--outline"
          onClick={onStop}
          aria-label="Stop"
        >
          Stop
        </button>
      ) : (
        <button
          type="submit"
          className="btn-app btn-app--primary"
          disabled={!draft.trim() || disabled}
        >
          Send
        </button>
      )}
    </form>
  );
};

export default ChatComposer;
